import { baseUrl } from './routes';

export class SettingsRoutes {
  static get settings(): string {
    return `${baseUrl}/settings`;
  }

  static get setting(): string {
    return `${baseUrl}/settings`;
  }

  static get roles(): string {
    return `${baseUrl}/settings/roles`;
  }

  static get featureFlags(): string {
    return `${baseUrl}/settings/feature-flags`;
  }

  static get insuranceTextsFixed(): string {
    return `${baseUrl}/settings/insurance-texts-fixed`;
  }

  static get systemLogs(): string {
    return `${baseUrl}/settings/system-logs`;
  }

  static get loginSessions(): string {
    return `${baseUrl}/settings/login-sessions`;
  }

  static get mySessions(): string {
    return `${baseUrl}/settings/my-sessions`;
  }

  static get general(): string {
    return `${baseUrl}/settings/general-settings`;
  }

  static get bank(): string {
    return `${baseUrl}/settings/bank-settings`;
  }

  static get email(): string {
    return `${baseUrl}/settings/email-settings`;
  }

  static get localization(): string {
    return `${baseUrl}/settings/localization-details`;
  }

  static get others(): string {
    return `${baseUrl}/settings/others-settings`;
  }

  static get payment(): string {
    return `${baseUrl}/settings/payment-settings`;
  }

  static get seo(): string {
    return `${baseUrl}/settings/seo-settings`;
  }

  static get socialLinks(): string {
    return `${baseUrl}/settings/social-links`;
  }

  static get social(): string {
    return `${baseUrl}/settings/social-settings`;
  }

  static get theme(): string {
    return `${baseUrl}/settings/theme-settings`;
  }

  static get weeklyReports(): string {
    return `${baseUrl}/settings/weekly-reports-generation`;
  }

  static get siteAlertBanner(): string {
    return `${baseUrl}/settings/site-alert-banner`;
  }

  static get objectiveTemplates(): string {
    return `${baseUrl}/settings/objective-templates`;
  }
}
